// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'X:/workflow/frontend/node_modules/.pnpm/@umijs+renderer-react@4.6.3_8dbdbc5f51130e80bf63592c814f3a07/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
